const headerMenuStyles = {
  userMenuWrap: {
    justifyContent: "space-between",
    padding: "0 2rem",
    height: 75,
  },
  userBtn: {
    height: "auto",
    textAlign: "left",
  },
};

export default headerMenuStyles;
